import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import {
  collection,
  addDoc,
  doc,
  getDoc,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import '../style/common.css';
import './form.css';
import AdminSidebar from '../components/AdminSidebar';

function CreatePO() {
  const [po, setPO] = useState({
    number: '',
    base_amount: '',
    gst: '',
    total_amount: '',
    date: '',
    location: '',
    jc_number: '',
    description: '',
    deadline: '',
    client: '',
  });

  const [customClient, setCustomClient] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });
  const navigate = useNavigate();

  const clientOptions = [
    'DLF', 'Medanta Gurgaon', 'Medanta Lucknow', 'Medanta Noida','Medanta Patna',
    'JLL', 'Cushman & Wakefield', 'Persistant', 'CBRE',
    'Grand Thorton', 'Lenskart', 'FIS', 'Assimilate',
    'Candor G1', 'Candor G2', 'Candor Noida', 'Other'
  ];
  useEffect(() => {
    const base = parseFloat(po.base_amount) || 0;
    const gst = parseFloat(po.gst) || 0;
    const total = base + (base * gst / 100);
    setPO(prev => ({ ...prev, total_amount: total.toFixed(2) }));
  }, [po.base_amount, po.gst]);

  useEffect(() => {
    const fetchUser = async () => {
      const userRef = doc(db, 'users', auth.currentUser.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        setCurrentUser(userSnap.data());
      }
    };
    fetchUser();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      number, base_amount, gst, total_amount,
      date, location, jc_number, description, deadline, client
    } = po;

    if (
      !number || !base_amount || !gst || !total_amount || !date ||
      !location || !jc_number || !description || !deadline ||
      !client || (client === 'Other' && !customClient.trim())
    ) {
      setMessage({ type: 'error', text: 'Please fill all fields.' });
      return;
    }

    const jcPattern = /^[A-Za-z0-9]+$/;
    if (!jcPattern.test(jc_number.trim())) {
      setMessage({
        type: 'error',
        text: 'JC Number must contain only letters and numbers (no special characters).'
      });
      return;
    }

    try {
      const jcQuery = query(
        collection(db, 'purchase_orders'),
        where('jc_number', '==', jc_number.trim())
      );
      const jcSnap = await getDocs(jcQuery);
      if (!jcSnap.empty) {
        setMessage({
          type: 'error',
          text: 'JC Number already exists. Please use a unique JC Number.'
        });
        return;
      }

      await addDoc(collection(db, 'purchase_orders'), {
        po_number: number,
        po_base_amount: parseFloat(base_amount),
        po_gst: parseFloat(gst),
        tax_percentage: parseFloat(gst), // Add this line
        po_total_amount: parseFloat(total_amount),
        po_date: date,
        location,
        description,
        deadline,
        jc_number: jc_number.trim(),
        client: client === 'Other' ? customClient.trim() : client,
        created_by: auth.currentUser.uid,
        assigned_to: null,
        balance_amount: parseFloat(total_amount),
        completed: false
      });
      

      setMessage({ type: 'success', text: 'PO Created Successfully.' });
      setTimeout(() => navigate('/admin'), 1500);
    } catch (err) {
      console.error('Error creating PO:', err);
      setMessage({ type: 'error', text: 'Failed to create PO. Try again.' });
    }
  };

  return (
    <div className="dashboard-wrapper">
      <AdminSidebar user={currentUser} />

      <div className="dashboard-content">
        <h2 className="form-title">Create Purchase Order</h2>

        {message.text && (
          <div className={`form-alert ${message.type}`}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="styled-form">
          <div className="form-row">
            <label>PO Number</label>
            <input
              type="text"
              value={po.number}
              onChange={(e) => setPO({ ...po, number: e.target.value })}
            />
          </div>

          <div className="form-row">
            <label>JC Number</label>
            <input
              type="text"
              value={po.jc_number}
              onChange={(e) => setPO({ ...po, jc_number: e.target.value })}
            />
          </div>

          <div className="form-row">
            <label>Client</label>
            <select
              value={po.client}
              onChange={(e) => setPO({ ...po, client: e.target.value })}
            >
              <option value="">Select Client</option>
              {clientOptions.map((c, idx) => (
                <option key={idx} value={c}>{c}</option>
              ))}
            </select>
          </div>

          {po.client === 'Other' && (
            <div className="form-row">
              <label>Enter Client Name</label>
              <input
                type="text"
                value={customClient}
                onChange={(e) => setCustomClient(e.target.value)}
                placeholder="Enter client name"
              />
            </div>
          )}

          <div className="form-row">
            <label>Description</label>
            <textarea
              rows={3}
              value={po.description}
              onChange={(e) => setPO({ ...po, description: e.target.value })}
            ></textarea>
          </div>

          <div className="form-row">
            <label>Location</label>
            <input
              type="text"
              value={po.location}
              onChange={(e) => setPO({ ...po, location: e.target.value })}
            />
          </div>

          <div className="form-row">
            <label>Base Amount (₹)</label>
            <input
              type="number"
              value={po.base_amount}
              onChange={(e) => setPO({ ...po, base_amount: e.target.value })}
            />
          </div>

          <div className="form-row">
            <label>GST (%)</label>
            <input
              type="number"
              value={po.gst}
              onChange={(e) => setPO({ ...po, gst: e.target.value })}
            />
          </div>

          <div className="form-row">
            <label>Total Amount (₹)</label>
            <input
              type="text"
              value={po.total_amount}
              disabled
              style={{ backgroundColor: '#eee', fontWeight: '600' }}
            />
          </div>

          <div className="form-row">
            <label>PO Creation Date</label>
            <input
              type="date"
              value={po.date}
              onChange={(e) => setPO({ ...po, date: e.target.value })}
            />
          </div>

          <div className="form-row">
            <label>PO Deadline Date</label>
            <input
              type="date"
              value={po.deadline}
              onChange={(e) => setPO({ ...po, deadline: e.target.value })}
            />
          </div>

          <button type="submit" className="submit-btn">Create PO</button>
        </form>
      </div>
    </div>
  );
}

export default CreatePO;
